import { render } from "./HelpTextTooltip.vue?vue&type=template&id=1bba2c51"
import script from "./HelpTextTooltip.vue?vue&type=script&lang=js"
export * from "./HelpTextTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HelpTextTooltip.vue"]])

export default __exports__